export const testCases = [
    {
        id: "admin", label: "Create a case with name, phone only as Admin login", browsers: {
            chrome: "running",
            firefox: "running",
            microsoft: "success"
        }
    },
    {
        id: "attorney", label: "Create a case with name, phone only as Attorney login", browsers: {
            chrome: "faild",
            firefox: "running",
            microsoft: "success"
        }
    },
    {
        id: "paralegal", label: "Create a case with name, phone only as Paralegal login", browsers: {
            chrome: "sucess",
            firefox: "running",
            microsoft: "success"
        }
    },
    {
        id: "broker", label: "Create a case with name, phone only as Broker login", browsers: {
            chrome: "running",
            firefox: "running",
            microsoft: "success"
        }
    },
    {
        id: "invalid-email", label: "If enter invalid email, Verify and Bypass Button",
        browsers: {
            chrome: "running",
            firefox: "running",
            microsoft: "running"
        }
    },
    {
        id: "bypass-validation", label: "On Click Bypass remove validation on email",
        browsers: {
            chrome: "faild",
            firefox: "faild",
            microsoft: "success"
        }
    },
    {
        id: "treatment-fund", label: "Treatment fund selected then test validation", browsers: {
            chrome: "running",
            firefox: "running",
            microsoft: "running"
        }
    },
    {
        id: "prior-fund", label: "Prior fund selected then test validation",
        browsers: {
            chrome: "running",
            firefox: "running",
            microsoft: "running"
        }
    }
];

export const browsers = [
    { id: "chrome", color: "#F97316", icon: "/img/chrome.png" },
    { id: "mozilla", color: "#EF4444", icon: "/img/firefox.png" },
    { id: "edge", color: "#A855F7", icon: "/img/browser.png" }
];

export const topIconList = [
    {
        id: 0,
        img_path: '/img/fb-icon-top.png',
    },
    {
        id: 1,
        img_path: '/img/insta_icon_top.png',
    },
    {
        id: 2,
        img_path: '/img/twitter_icon-top.png',
    },
    {
        id: 3,
        img_path: '/img/link-icon-top.png',
    },
];

export const cardsData = [
    {
        id: 1,
        title: "Admin | Create Case",
        status: "Success",
        message: "Test case success on multiple browsers",
        details: [
            {
                key: "Chrome",
                title: "Chrome Test Case",
                status: "Test Case Success",
                icon: "/img/chrome.png",
                description:
                    "All validation messages are displaying correctly in Client Information while creating case",
                action: "View Screenshot",
                screenShot: "/img/accordian.png",
                failuresData: {
                    tests: 4,
                    assertions: 2,
                    failures: 1,
                },
            },
            {
                key: "backend",
                title: "Backend Script",
                status: "Test Case Success",
                icon: "/img/backend.png",
                description:
                    "Validation passed: 'email' key exists in the array",
                action: "View Results",
                time: "00:00.021",
                memory: "6.00 MB",
                failuresData: {
                    tests: 4,
                    assertions: 2,
                    failures: 1,
                },
            },
        ],
    },

    {
        id: 2,
        title: "Admin | Update Case",
        status: "Failed",
        message: "Test case failed on chrome browser",
        details: [
            {
                key: "Chrome",
                title: "Chrome Test Case",
                status: "Test Case Failed",
                icon: "/img/chrome.png",
                description:
                    "Email validation error is not showing in Client Information while creating case",
                action: "View Screenshot",
                screenShot: "/img/accordian2.png",
                failuresData: {
                    tests: 4,
                    success: 2,
                    failures: 1,
                },
            },
            {
                key: "backend",
                title: "Backend Script",
                status: "Test Case Failed",
                icon: "/img/backend.png",
                description:
                    "Failed asserting that an array has the key 'email'",
                action: "View Results",
                time: "00:00.021",
                memory: "6.00 MB",
                failuresData: {
                    tests: 4,
                    assertions: 2,
                    failures: 2,
                    error: [
                        {
                            heading:
                                "FormValidatorTest::testInvalidEmailFormat",
                            content:
                                "Failed asserting that an array has the key",
                            type: "email.",
                            filePath: "/tests/FormValidatorTest.php:27",
                        },
                        {
                            heading:
                                "FormValidatorTest::testInvalidPhoneFormat",
                            content:
                                "Failed asserting that an array has the key",
                            type: "phone.",
                            filePath: "/tests/FormValidatorTest.php:29",
                        },
                    ],
                },
            },
        ],
    },
];

export const historyData = [
    {
        date: "04/14/2023",
        time: "00:00a",
        memory: "6.00 MB",
        status: "Success",
        tests: 5,
        success: 5,
        failures: 1,
    },
    {
        date: "04/13/2023",
        time: "00:00a",
        memory: "6.00 MB",
        status: "Success",
        tests: 5,
        success: 5,
        failures: 1,
    },
    {
        date: "04/12/2023",
        time: "00:00a",
        memory: "6.00 MB",
        status: "Success",
        tests: 5,
        success: 5,
        failures: 1,
    },
    {
        date: "04/11/2023",
        time: "00:00a",
        memory: "6.00 MB",
        status: "Success",
        tests: 5,
        success: 5,
        failures: 1,
    },
    {
        date: "04/10/2023",
        time: "00:00a",
        memory: "6.00 MB",
        status: "Success",
        tests: 5,
        success: 5,
        failures: 1,
    },
    {
        date: "04/09/2023",
        time: "00:00a",
        memory: "6.00 MB",
        status: "Success",
        tests: 5,
        success: 5,
        failures: 1,
    },
    {
        date: "04/08/2023",
        time: "00:00a",
        memory: "6.00 MB",
        status: "Success",
        tests: 5,
        success: 5,
        failures: 1,
    },
    {
        date: "04/14/2023",
        time: "00:00a",
        memory: "6.00 MB",
        status: "Failed",
        tests: 5,
        success: 5,
        failures: 1,
    },
    {
        date: "04/14/2023",
        time: "00:00a",
        memory: "6.00 MB",
        status: "Failed",
        tests: 5,
        success: 5,
        failures: 1,
    },
];

export const STATUS_CONFIG = {
    success: {
      bg: '#e8f5e9',
      border: '#26AA01',
      color: 'green',
      icon: '#26AA01',
      flag:'green'
    },
    running: {
      bg: '#ff64421c',
      border: '#ff6442',
      color: '#ff6442',
      icon: '#ff6442',
      flag:'#ff6442'
    },
    failed: {
      bg: '#ffebee',
      border: '#710000',
      color: '#6A0000',
      icon: '#5f2120',
      flag:'#FF4A4A'
    },
  };
